'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

var _constants = require('./constants');

var c = _interopRequireWildcard(_constants);

var DbInfo = (function (_Array) {
	_inherits(DbInfo, _Array);

	function DbInfo(arr) {
		var _this = this;

		_classCallCheck(this, DbInfo);

		_Array.call(this);
		arr.forEach(function (item) {
			return _this.push(item);
		});
	}

	DbInfo.prototype.get = function get(id) {
		for (var i = 0; i < this.length; i++) {
			if (this[i].id == id) {
				return this[i].title;
			}
		}
	};

	DbInfo.prototype.getItem = function getItem(id) {
		for (var i = 0; i < this.length; i++) {
			if (this[i].id == id) {
				return this[i];
			}
		}
	};

	DbInfo.prototype.asArray = function asArray() {
		var _this2 = this;

		var arr = [];

		var _loop = function () {
			var keys = _Object$keys(_this2[i]);
			var o = {};
			keys.forEach(function (key) {
				o[key] = _this2[i][key];
			});
			arr.push(o);
		};

		for (var i = 0; i < this.length; i++) {
			_loop();
		}
		return arr;
	};

	return DbInfo;
})(Array);

var DbInfos = {};

DbInfos.YesNo = new DbInfo([{ id: 1, title: 'Ano' }, { id: 0, title: 'Ne' }]);

DbInfos.InvoiceStatus = new DbInfo([{ id: c.INVOICE_STATUS.NEW, title: 'vystaveno' }, { id: c.INVOICE_STATUS.PAYED, title: 'zaplaceno' }]);

DbInfos.TicketStatus = new DbInfo([{ id: 1, title: 'nový' }, { id: 2, title: 'k analýze' }, { id: 3, title: 'řeší se' }, { id: 4, title: 'hotovo' }]);

module.exports = DbInfos;


/*****************
 ** WEBPACK FOOTER
 ** ./src/dbinfo.js
 ** module id = 43
 ** module chunks = 2
 **/